import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * 登录服务
 * @param name 账户名
 * @param password 账户密码
 * @returns {Promise<AxiosResponse<T>>}
 */
/* export async function login(name, password) {
  return request(LOGIN, METHOD.POST, {
    "username": name,
    "passwd": password
  },{headers:{'Content-Type':"application/x-www-form-urlencoded"}})
} */

export function login(data) {
  return request("".concat(BASE_URL) + "/user/login", METHOD.POST, data);
}
export function getCaptcha() {
  return request("".concat(BASE_URL) + "/captcha/getcaptcha", METHOD.GET);
}
export function _logout() {
  return request("".concat(BASE_URL) + "/user/logout", METHOD.DELETE);
}
export function getRoutesConfig() {
  return _getRoutesConfig.apply(this, arguments);
}

/**
 * 退出登录
 */
function _getRoutesConfig() {
  _getRoutesConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request(ROUTES, METHOD.GET));
      }
    }, _callee);
  }));
  return _getRoutesConfig.apply(this, arguments);
}
export function logout() {
  _logout().then(function (res) {
    if (res.code == 200) {
      localStorage.removeItem(process.env.VUE_APP_ROUTES_KEY);
      localStorage.removeItem(process.env.VUE_APP_PERMISSIONS_KEY);
      localStorage.removeItem(process.env.VUE_APP_ROLES_KEY);
      removeAuthorization();
    }
  });
}
export function updatepwd(_x) {
  return _updatepwd.apply(this, arguments);
}
function _updatepwd() {
  _updatepwd = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          return _context2.a(2, request("".concat(BASE_URL) + "/admin/user/updatepwd", METHOD.PUT, data, {
            headers: {
              'Content-Type': "application/x-www-form-urlencoded"
            }
          }));
      }
    }, _callee2);
  }));
  return _updatepwd.apply(this, arguments);
}
export default {
  login: login,
  logout: logout,
  updatepwd: updatepwd
};